import React, { useState, useEffect, useMemo, useRef, useContext, useCallback, memo, useReducer } from "react"
//import { useQuery } from "@tanstack/react-query";
//import { useReferentes } from "../context/ReferentesContext";
//import { ReferentesContext } from "../context/ReferentesContext";

//import { useDebugFormContext } from "../hooks/useDebugFormContext";

import { useFormContext } from "../context/FormContext";
import { NuevaONGContext } from "../context/NuevaONGContext";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//import { SocketContext } from "../context/socketContext";

import Select from "react-select";

import { Input, Label, Button, Select_simple } from "./ui"
//import { useAuth } from "../hooks/useAuth";
import { AuthContext } from "../context/authContext";
import { useTheme } from "../context/ThemeContext";
import { useGeo } from "../context/GeoContext";
import {
    optionsPartido, optionsTipoSubsidio, optionsEncargadoProyecto, optionsPrograma, optionsModalidadUNO, optionsModalidadDOS,
    optionsTipoContratacion, optionsEstado, optionsTipoProyecto, optionsIdentificacionCatastral, optionsBarrioTipo,
    optionsAreaResponsable
} from "../datos/options"

//Subformularios (nietos)
import TipoProyectoSubform from "./TipoProyectoSubform"; //formulario Tipo Proyecto y Subtipo
import ExpedienteSubform from "./ExpedienteSubform"; //formulario Expedientes (relacion uno a varios ---> guardar en tabla: obras_expediente )

//import Prueba from "./prueba";
import InputMontoObra from "./InputMontoObra"
import SubsidioForm from "./SubsidioForm";

import Modal2 from "./Modal2";
import InfoButtonWithPopover from "./InfoButtonWithPopover";

import { adjustDateForTimezone } from '../utils/dateUtils';

//import io from "socket.io-client"; //13-ENE-25

//VER QUE SE RECUPERA ---> registro, setRegistro, estadoApp, formRows, setFormRows, editandoInput, setEditandoInput, setModoEdicion, socket, bloquear
//25JUL2025: onDataFromNieto se quito
/*const FormA = ({ estadoAppX, registro, onRegistroChange, onDataChangeSub, handleValidationChange, alSincronizar,
    handleLocalDataChange
 }) => {*/

const FormA = ({ estadoAppX }) => {

    // Usa el hook con una etiqueta para identificar los logs
    //const formAContext = useDebugFormContext('FormA');
    //donde uso formAContext?
    //console.log("FormAContext en formA", formAContext)
    console.log("estadoAppX en formA", estadoAppX)

    const {
        formA,
        updateField,
        validateForm
    } = useFormContext();

    // Obtener datos del formulario A
    const { datosGenerales } = formA;

    const [_, forceUpdate] = useReducer(x => x + 1, 0);
    console.log("DATOS GENERALES en formA", datosGenerales)
    console.log("FORMA en formA", formA)

    const { isDarkMode } = useTheme();
    const { role } = useContext(AuthContext);
    const { drawnFeatures } = useGeo();

    // 1. Usamos useRef para rastrear si el componente está montado
    const isMounted = useRef(true);

    //console.log("REGISTRO en formA", registro)

    const { nuevaONG, ongsRefetch} = useContext(NuevaONGContext);
    //const { nuevoReferente } = useContext(ReferentesContext);

    //1- destructurar registro
    /*
    const {
        id_partido_obra,
        nombre_obra, //campo obligatorio
        fecha_carga,
        fecha_actualizacion: fechaActualizacionRaw, //renombramos registro.fecha_actualizacion a fechaActualizacionRaw
        encargado_proyecto,//responsable_interno, //campo obligatorio
        //presidente_ong, //09
        area_responsable, //nuevo 11-jun-2025 //campo obligatorio
        programa_lineamiento, //10
        modalidad, //10_1 ---> NUEVO 7-feb-25
        //referente_politico, //11 ---> se va por ahora 7-feb-25 //volvio 24-abril-2025 //se va nuevamente 26-may-25
        referente_politico_nombre,
        //contacto_proyecto, //12  ---> se va por ahora 7-feb-25
        beneficiarios, //13 si es numerico es NULL
        monto_obra, //14_1
        fecha_imputacion, //14_2
        tipo_contratacion, //15
        plazo_obra, //20
        estado, //16 
        //tipo_proyecto, //17 POR AHORA NO ---> iria a una tabla aparte (por Tipo)
        //categorias_items_obras, //18 ---> POR AHORA NO
        descripcion_proyecto, //19
        lc_21_localidad,//21 prueba
        lc_22_identificacion_catastral,
        lc_22_1_datos_catastrales,
        lc_22_2_cuadro_calles,
        lc_23_observaciones_localizacion,
        lc_24_titular_dominio,

        partido_nombre, //nuevo
        partido,//campo obligatorio
        array_obras_expediente, //---> igual que en la Base de datos
        array_tipo_subtipo_proyecto, // ---> igual que en la Base de datos
        barrio_tipo,
        barrio_rppvap_nombre,
        barrio_otro_nombre
    } = registro
    */
    //console.log("nombre_obra en REGISTRO ---> ", nombre_obra)

    const [formDataLocalizacion, setFormDataLocalizacion] = useState({ //para manejor ubicacion
        lc_21_localidad: '',
        lc_22_identificacion_catastral: '',
        lc_22_1_datos_catastrales: '',
        lc_22_2_cuadro_calles: '',
        lc_23_observaciones_localizacion: ''
    });

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const [barriosRPPVAP, setBarriosRPPVAP] = useState([]); //estado para guardar los nombres de los barrios filtrados por partido
    

    //ESTADOS LOCAL - para contador de caracteres
    const [textInput1, setTextInput1] = useState(''); //input descripcion_proyecto
    const [textInput2, setTextInput2] = useState(''); //input lc_23_observaciones_localizacion

    //inicia estados locales para mantener cambios en local hasta sincronizar con el padre
    //crear un objeto vacio, para luego ir agregando las keys que tiene cambios
    const [localData, setLocalData] = useState({
        nombre_obra: '',
        beneficiarios: '',
        plazo_obra: '',
        partido: '',
        partido_nombre: '',
        barrio_tipo: '',
        barrio_rppvap_nombre: '',
        barrio_otro_nombre: ''
        
    });
    console.log("PUMA CAMBIOS LOCALES", localData) 
    
    // Estados RECUPERAR
    const [nombrePartido, setNombrePartido] = useState(""); //6FEB25 - usar para el component SubsidioForm
    const [tipoSubsidio, setTipoSubsidio] = useState('');
    console.log("Tipo de Subsidio estado local en hijo --->", tipoSubsidio)

    const [organismoSolicitante, setOrganismoSolicitante] = useState('');
    console.log("Organismo Solicitante estado local en hijo --->", organismoSolicitante)

    const [formDataTipo, setFormDataTipo] = useState([]); //7-FEB-25 para manejar estado del formulario de Tipo/Subtipo
    console.log("Datos Tipo Proyecto y SubTipo", formDataTipo)

    //const [formattedValue, setFormattedValue] = useState(''); // Valor formateado visualmente (con $)
    //const [numericValue, setNumericValue] = useState(null); // Valor numérico real

    const [selectedOptions, setSelectedOptions] = useState([]);

    const [startDate, setStartDate] = useState(new Date());

    // 1. Obtener referentes con useQuery
    //abre recuperado
    /* //REFERENTES por ahora se va
    const { data: referentes = [], refetch } = useQuery({
        queryKey: ['referentes'],
        queryFn: () => fetch('/api/todosReferentes').then(res => res.json()),
        select: (data) => [
            { value: '', label: 'Seleccionar...', disabled: true }, // Opción inicial
            ...data.map(item => ({
                value: item.id.toString(),
                label: item.nombre
            }))
        ],
        onSuccess: (transformedData) => {
            console.log('Referentes transformados:', transformedData);
        }
    });

    const { registerRefetch } = useReferentes();

    useEffect(() => {
        registerRefetch(refetch);
    }, [refetch]);

    //24-abr-2025: estado para las options recibidas desde la api
    const [opcionesReferente, setOpcionesReferente] = useState([]);
    */
   //cierra recuperado

    const bloquear = false; //harcodeado ----> CHANGE #21FEB

    //4- UseMemo y useCallbacks******************
    //NUEVO callback solo para pruebas nombre_obra -NO USAR POR AHORA -21nov2025-
    const handleInputChangeNombreObra = useCallback((event) => {
        const { value } = event.target;
        setLocalData(prev => ({ 
            ...prev, 
            nombre_obra: value 
        }));
    }, []);

    
    //NUEVA #21FEB
    //ANTES un callback para manejar los cambios en los inputs
    /*
    const handleInputChange = useCallback((event) => {
        const { name, value } = event.target;
        console.log("name", name)
        console.log("value", value)

        
        // Actualiza una parte del 'registro' existente, manteniendo la inmutabilidad
        //agregar casos especiales
        if (name === 'beneficiarios') {
            if (value === '' || /^\d{0,5}$/.test(value)) {
                onRegistroChange({ ...registro, beneficiarios: value }); //RECUPERADO #21FEB
            }
        } else if (name === 'plazo_obra') {
            console.log("ESTÄ ENTRANDO ACA???")
            if (value === '' || /^\d{0,3}$/.test(value)) {
                onRegistroChange({ ...registro, plazo_obra: value }); //RECUPERADO #21FEB
            }
        } else if (name == 'partido') { //maneja el estado de dos propiedades distintas
            if (value > 0) {
                const select = event.target;
                const opcionSeleccionada = select.options[select.selectedIndex];
                const textoOpcionSeleccionada = opcionSeleccionada.text;
                onRegistroChange({ ...registro, partido: value, partido_nombre: textoOpcionSeleccionada }); //RECUPERADO #21FEB
                setNombrePartido(textoOpcionSeleccionada)//(e.target.options[e.target.selectedIndex].text)
            } else {
                onRegistroChange({ ...registro, partido: value, partido_nombre: "" }); // ----> RECUPERADO #21FEB
            }            
        } 
       
        else if (name === 'barrio_tipo') {
            onRegistroChange({ ...registro, barrio_tipo: value });
        } else {
            onRegistroChange({ ...registro, [name]: value, });
        }

        if (name === 'descripcion_proyecto') {
            //actualizamos el estado local -solo para el contador de caracteres
            setTextInput1(value)            
        }

        if (name === 'lc_23_observaciones_localizacion') {
            //actualizamos el estado local -solo para el contador de caracteres
            setTextInput2(value)            
        }

    }, [registro, onRegistroChange]);*/


    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        // Para campos de tipo checkbox
        const fieldValue = type === 'checkbox' ? checked : value;
        
        if (name === 'partido') {
            // Manejar el cambio de partido
            if (value > 0) {
                const select = e.target;
                const opcionSeleccionada = select.options[select.selectedIndex];
                const textoOpcionSeleccionada = opcionSeleccionada.text;
                
                // Actualizar el contexto
                updateField('formA', 'datosGenerales', 'partido', value);
                updateField('formA', 'datosGenerales', 'partido_nombre', textoOpcionSeleccionada);
                
                // Actualizar el estado local si es necesario
                setNombrePartido(textoOpcionSeleccionada);
            } else {
                // Si no hay partido seleccionado
                updateField('formA', 'datosGenerales', 'partido', value);
                updateField('formA', 'datosGenerales', 'partido_nombre', '');
                setNombrePartido('');
            }       
        } else if (name.includes('.')) {
            // Para campos anidados (si es necesario)
            const [section, field] = name.split('.');
            updateField('formA', section, field, fieldValue);
        } else {
            // Para campos en datosGenerales
            updateField('formA', 'datosGenerales', name, fieldValue);
        }
    };    

    //console.log("ACCION C ---form A--->", accion)
    //const socket = io({ path: "/socket.io" }); // 13-ENE-25
    //const socket = useContext(SocketContext) 

    // Formatear la fecha al desestructurar
    //ANTES
    /*
    const fecha_actualizacion = useMemo(() => { //crea una nueva variable fecha_actualizacion, no tiene relacion con registro.fecha_actualizacion
        if (!fechaActualizacionRaw) return null;
        try {
            const fecha = new Date(fechaActualizacionRaw);
            if (isNaN(fecha.getTime())) return null;
            
            const fechaAjustada = new Date(fecha)
            fechaAjustada.setMinutes(fechaAjustada.getMinutes() + fechaAjustada.getTimezoneOffset())
            return fechaAjustada;
        } catch (error) {
            console.error('Error al formatear fecha:', error);
            return null;
        }
    }, [fechaActualizacionRaw]); 
    */ 
   // Reemplaza el useMemo antiguo por esto:
    const fechaActualizacion = useMemo(() => {
        if (!datosGenerales.fecha_actualizacion) return null;
        if(estadoAppX === "nuevo"){
            return null;
        }
        try {
            const fecha = new Date(datosGenerales.fecha_actualizacion);
            if (isNaN(fecha.getTime())) return null;

            const fechaAjustada = new Date(fecha);
            fechaAjustada.setMinutes(fechaAjustada.getMinutes() + fechaAjustada.getTimezoneOffset());
            return fechaAjustada;
        } catch (error) {
            console.error('Error al formatear fecha:', error);
            return null;
        }
    }, [datosGenerales.fecha_actualizacion]);

    const openModal = () => setModalIsOpen(true);
    const closeModal = () => setModalIsOpen(false);

    /* ----> RECUPERAR #21FEB
    useEffect(()=>{

        if(socket){

            const procesarEditInput = (usuario, data) =>{
                console.log("QUE USUARIO ESTA EDITANDO", usuario)
                console.log("QUE INPUT ID ESTÁ EDITANDO OTRO USUARIO", data)
    
                //setArrayInputs(...arrayInputs, data.value)
            }
            
            socket.on("input_editado_por_otro_usuario", procesarEditInput)            
    
            return () => {
                socket.off("input_editado_por_otro_usuario", procesarEditInput)
            }              

        }          

    }, [])
    */

    //5- UseEffects *******************
    // Agrega este efecto para depurar
    useEffect(() => {
        console.log('TORO FormA - formA actualizado:', formA);
        console.log('TORO FormA - datosGenerales actualizado:', datosGenerales);
    }, [formA, datosGenerales]);
    
    //NOTA #19NIV25: pensar como pasar estado de 'registro' cuando cambio de pestaña o cuando doy guardar desde 'Inicio'
    // al previsualizr PDF
    //Evitar pasar estado (y re render) por cada cambio en formA

    //solo al montar
    /*
    useEffect(() =>{
        setLocalData({
            nombre_obra: registro.nombre_obra || '',
        })
    }, [registro.nombre_obra])
    */

     // useEffect para inicializar los estados cuando el componente se monta en modo de edición
    /*
     useEffect(() => {
        if (registro && registro.monto_obra) {
            const numericMonto = parseFloat(registro.monto_obra);
            if (!isNaN(numericMonto)) {
                // Formatear el valor numérico para la vista
                const formatted = `$${numericMonto.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
                setFormattedValue(formatted);
                setNumericValue(numericMonto);
            }
        } else if(registro && estadoAppX === "nuevo"){
            setFormattedValue('');
            setNumericValue(null);
        }
    }, [registro]); // Se ejecuta cada vez que el objeto 'obra' cambia

    useEffect(() => {
        if (nuevaONG) {
            if (typeof ongsRefetch === 'function') { // Añade esta verificación
                ongsRefetch();
            } else {
                console.warn('ongsRefetch no es una función.');
            }
            // Aquí puedes realizar las acciones necesarias en formA
            // como actualizar su propio estado, mostrar la nueva ONG en una lista, etc.
            // Disparar la refetch de la lista de ONGs
            //ongsRefetch();
        }
    }, [nuevaONG, ongsRefetch]); // El efecto se ejecutará cuando nuevaONG cambie

    useEffect(() => {
        if (barrio_tipo === 'RPPVAP' && partido) {
            fetch(`/api/barrios/barrios_rppvap?partido=${partido}`)
                .then(res => res.json())
                .then(data => setBarriosRPPVAP(data))
                .catch(err => console.error('Error fetching barrios:', err));
        }
    }, [barrio_tipo, partido]);
    
    useEffect(() => {
        if (numericValue !== null) {
            //setRegistro({ ...registro, monto_obra: numericValue}) //RECUPERAR #21FEB
            onRegistroChange({ ...registro, monto_obra: numericValue }) //->>>>>>>>><>>>>>>>>> CAMBIA EN EL handler
        }
    }, [numericValue])    

    useEffect(() => {
        //setRegistro({ ...registro, modalidad: ""}) //RECUPERAR #21FEB
    }, [programa_lineamiento])

    useEffect(() => {
        if (partido !== 0) {
            if (estadoAppX === 'nuevo') {
                console.log("Reseteando barrios - Nuevo proyecto con partido válido");
                onRegistroChange({
                    ...registro,
                    barrio_tipo: '',
                    barrio_rppvap_nombre: null,
                    barrio_otro_nombre: ''
                });
            } else if (estadoAppX === 'ediT' && registro.partido !== partido) {
                console.log("Reseteando barrios - Cambio de partido en edición");
                onRegistroChange({
                    ...registro,
                    barrio_tipo: '',
                    barrio_rppvap_nombre: null,
                    barrio_otro_nombre: ''
                });
            }
        }
    }, [partido]); 
    */    
    


    useEffect(() => {
        if (estadoAppX === 'nuevo') {
            
            const fechaActual = new Date();
            // Actualizar tanto la fecha de carga como la de actualización
            updateField('formA', 'datosGenerales', 'fecha_carga', fechaActual);
            //si es nuevo fecha_actualizacion debe ser null
            updateField('formA', 'datosGenerales', 'fecha_actualizacion', null);


        } else if (estadoAppX === 'ediT') {
            
            //updateField('formA', 'datosGenerales', 'fecha_actualizacion', new Date()); //-----> se maneja en el server al guardar la edicion
        }
    }, [estadoAppX])
    
    // Lógica de Validación
    /*
    useEffect(() => {        

        const esEncargadoValido = String(encargado_proyecto).trim() !== ''; 
        const esAreaValido = String(area_responsable).trim() !== ''; 
        const esPartidoValido = String(partido).trim() !== ''; 
        
        const camposObligatoriosLlenos = 
            localData.nombre_obra.trim() !== '' && 
            esEncargadoValido && 
            esAreaValido && 
            esPartidoValido; 
        
        // Comunicar el estado de validación al Padre
        handleValidationChange(camposObligatoriosLlenos);
        
    }, [localData.nombre_obra, encargado_proyecto, area_responsable, partido, handleValidationChange]); // ¡Añadir 'partido' aquí!
    */
    
    /*
    NO USAR NADA DE ESTO POR AHORA -21nov2025-
    // Sincronización al desmontar (cuando se cambia de pestaña)
    useEffect(() => {
        // Función de limpieza que se ejecuta justo antes de que el componente se desmonte

        // 3. Devolvemos la función de limpieza
        return () => {
            // 4. Esta línea se ejecuta ANTES del próximo render Y al desmontar.

            // 5. Establecer isMounted a false en el cleanup.
            // Si se ejecuta justo antes de unmount, esta es la última vez que se ejecuta.
            isMounted.current = false;

            // 6. ¡La Clave! Solo sincronizar si isMounted es FALSE 
            //    (indicando que el componente va a ser desmontado/reemplazado)
            if (isMounted.current === false) {
                //alSincronizar(localData);
                //onRegistroChange({ ...registro, nombre_obra: localData.nombre_obra, })

                //otra prueba
                handleLocalDataChange(localData);
                console.log('PUMA FormA sincronizado con el padre al cambiar de pestaña.', localData);
            }
        };
    }, [alSincronizar, localData]); // Depende de la función de sincronización y el estado local
    //alSincronizar, localData <-- Array de dependencias vacío para que solo se ejecute en el desmontaje
    */    

    /*
    // Sincronización al desmontar (cuando se cambia de pestaña)
    useEffect(() => {
        // Función de limpieza que se ejecuta justo antes de que el componente se desmonte
        return () => {
            // Verificar si hay datos locales para sincronizar
            if (Object.keys(localData).length > 0) {
                console.log('PUMA Sincronizando datos locales con el padre:', localData);
                alSincronizar(localData); // Envía los datos locales al padre
            } else {
                console.log('No hay cambios locales para sincronizar');
            }
        };
    }, [alSincronizar]); // Solo dependemos de alSincronizar
    */

    // 6- Funciones Manejo de fechas y Handlers******************
    //eliminar _fechaCarga
    //#19dic205 - comentar por ahora _fecha_imputacion
    /*
    let _fecha_imputacion = null;
    if (datosGenerales.fecha_imputacion === null) {
        _fecha_imputacion = null;
    } else if (datosGenerales.fecha_imputacion !== null || datosGenerales.fecha_imputacion !== "") {
        _fecha_imputacion = new Date(datosGenerales.fecha_imputacion);
        _fecha_imputacion.setMinutes(_fecha_imputacion.getMinutes() + _fecha_imputacion.getTimezoneOffset())
    }
    */

    /**FUNCIONES */ 
    //contador de caracteres #19NOV25:
    //podría definir un limite constante, pero de esta manera se puede usar para cualquier input e ir variando el limite
    const contadorCaracteresRestantes = (limite, texto) => {
        // Si el texto es null o undefined, usar string vacío
        const longitud = texto ? texto.length : 0;
        // Asegurarse de que el límite sea un número válido
        const limiteValido = limite || 0;
        // Calcular caracteres restantes, asegurando que no sea negativo
        return Math.max(0, limiteValido - longitud);
    }

    const onChange = e => {
        console.log(e)
        console.log("SI EL CAMBIO VIENE DESDE SOCKET TAMBIEN LO TOMA ACA???")

        // ** validaciones
        //const valor = e.target.value;
        //const nombre = e.target.name;
        const { name, value } = e.target; //lo mismo en una sola linea        

        // Validar que el valor sea un número entero
        if (name === 'beneficiarios') {
            if (value === '' || /^\d{0,5}$/.test(value)) {
                //setRegistro({...registro, beneficiarios: value}); //RECUPERADO #21FEB
            }
        } else if (name === 'plazo_obra') {
            console.log("ESTÄ ENTRANDO ACA???")
            if (value === '' || /^\d{0,3}$/.test(value)) {
                //setRegistro({...registro, plazo_obra: value}); //RECUPERAR #21FEB
            }
        } else if (name == 'partido') { //maneja el estado de dos propiedades distintas
            if (value > 0) {
                const select = e.target;
                const opcionSeleccionada = select.options[select.selectedIndex];
                const textoOpcionSeleccionada = opcionSeleccionada.text;
                //setRegistro({...registro, partido: value, partido_nombre: textoOpcionSeleccionada}); //RECUPERADO #21FEB
            } else {
                //setRegistro({...registro, partido: value, partido_nombre: ""}); // ----> RECUPERADO #21FEB
            }

        } else {
            //setRegistro({ ...registro, [e.target.name]: e.target.value }); // --->RECUPERAR #21FEB
        }


        //setEditandoInput({ ...editandoInput, id_input_editando : e.target.name}) ----> RECUPERAR #21FEB
        //setModoEdicion("manual") ----> RECUPERAR #21FEB ??????
        if (e.target.name === 'partido') {
            setNombrePartido(e.target.options[e.target.selectedIndex].text)
        }
    }  

    /*const onChangeLocalizacion = (e) => { //cambios localizacion
        const { name, value } = e.target;

        setFormDataLocalizacion(prev => ({
            ...prev,
            [name]: value
        }));
    };*/
    

    //ANTES
    /*
    const handleChangeDate = (item) => {
        const fecha = item.value;
        //setRegistro({ ...registro, [item.name]: fecha }); //RECUPERAR #21FEB
        onRegistroChange({ ...registro, [item.name]: fecha })
    }
    */
    // Después
    const handleChangeDate = (item) => {
        const fecha = item.value;
        updateField('formA', 'datosGenerales', item.name, fecha);
    }

    //ANTES
    /*
    const handleChangeFormattedValue = (newValue) => {
        setFormattedValue(newValue)
    }
    */
    // Después
    const handleChangeFormattedValue = (newValue) => {
        updateField('formA', 'datosGenerales', 'formattedValue', newValue);
    }

    //ANTES
    /*
    const handleChangeNumericValue = (newNumber) => {
        setNumericValue(newNumber)
    } 
    */
    // Después
    const handleChangeNumericValue = (newNumber) => {
        updateField('formA', 'datosGenerales', 'numericValue', newNumber);
    }   

    const handleChange = (selectedOption) => {
        setSelectedOptions(selectedOption);
    };    

    //MANTENER: manejar fecha de actualizacion con una funcion generica, evitar que se muestre un dia menos que el recibido desde la base
    //ANTES
    /*
    const manejarFechaActualizacion = (fecha_recibida) => {
        // Si no hay fecha o es una cadena vacía, retornar null
        if (!fecha_recibida) return null;
        
        // Crear un objeto Date a partir del input
        const fecha = new Date(fecha_recibida);
        
        // Verificar si la fecha es válida
        if (isNaN(fecha.getTime())) {
            console.error('Fecha inválida recibida:', fecha_recibida);
            return null;
        }
        
        // Ajustar por la zona horaria
        fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset());
        
        // Retornar la fecha formateada
        return fecha;
    }
    */
    // Uso con el contexto
    const handleFechaChange = (date, fieldName) => {
        updateField('formA', 'datosGenerales', fieldName, date);
    }

    //#24nov2025 - un useEffect para manejar el cambio de identificacion catastral en NO---> limpiar datos catastrales, dejar solo cuadro de calles
    useEffect(() => {
        if (datosGenerales.lc_22_identificacion_catastral === 'NO') {
            updateField('formA', 'datosGenerales', 'lc_22_1_datos_catastrales', '');
        } 
    }, [datosGenerales.lc_22_identificacion_catastral]);

    useEffect(() => {
        if (datosGenerales.barrio_tipo === 'RPPVAP' && datosGenerales.partido) {
            fetch(`/api/barrios/barrios_rppvap?partido=${datosGenerales.partido}`)
                .then(res => res.json())
                .then(data => setBarriosRPPVAP(data))
                .catch(err => console.error('Error fetching barrios:', err));
        }
    }, [datosGenerales.barrio_tipo, datosGenerales.partido]);

    //useEffect para limpiar barrio_rppvap cuando el barrio_tipo es Otro
    useEffect(() => {
        if (datosGenerales.barrio_tipo === 'OTRO') {
            updateField('formA', 'datosGenerales', 'barrio_rppvap_nombre', '');
        } else if (datosGenerales.barrio_tipo === 'RPPVAP') {
            updateField('formA', 'datosGenerales', 'barrio_otro_nombre', '');
        }
    }, [datosGenerales.barrio_tipo]);

    const fechaCargaAjustada = adjustDateForTimezone(datosGenerales.fecha_carga);
    const fechaActualizacionAjustada = adjustDateForTimezone(datosGenerales.fecha_actualizacion);
    const fechaImputacionAjustada = adjustDateForTimezone(datosGenerales.fecha_imputacion);

    return (
        //quite de form ---> md:max-w-sm
        // 
        //className= {`${bloquear ? "bg-gray-600  border-solid border-2 border-yellow-800 px-2 py-4 pointer-events-none opacity-80" : " bg-gray-600  border-solid border-2 border-yellow-800 px-2 py-4 "}`}
        <>

            <div className={`${bloquear ? "p-4 bg-white dark:bg-gray-900 pointer-events-none opacity-80 h-auto" : "p-4 bg-white dark:bg-gray-900 h-auto "}`} >

                <form className="space-y-2 ">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <div className="space-y-4 h-auto"> {/* COLUMNA UNO - mitad de DAtos generales*/}
                            <h2 className="text-xl font-bold dark:text-white mb-2">DATOS GENERALES</h2>

                            <div className="px-2">
                                <Label htmlFor="id">Id</Label>
                                <Input
                                    disabled
                                    id="id"
                                    name="id"
                                    type="text"
                                    placeholder="id"
                                    value={datosGenerales.id_partido_obra || ''}
                                    onChange={e => handleInputChange(e)}
                                />
                            </div>

                            <div className="px-2">
                                <Label htmlFor="partido">Partido</Label>
                                <Select_simple
                                    id="partido"
                                    //options={optionsPartido}
                                    options={[
                                        { value: '', label: 'Seleccionar...' },
                                        ...optionsPartido.map(c => ({ value: c.value, label: c.label }))
                                    ]}
                                    name="partido"
                                    value={datosGenerales.partido}
                                    onChange={e => handleInputChange(e)}
                                    required
                                />
                                <div>
                                    <p className="text-sm text-gray-500">
                                        Indicar el partido de mayor preponderancia
                                    </p>
                                </div>
                                {(datosGenerales.partido === 0 || datosGenerales.partido === "") && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Campo obligatorio
                                    </p>
                                )}
                            </div>

                            <div className="px-2">
                                <Label htmlFor="nombre_obra">Nombre del Proyecto / Alias</Label>
                                <Input
                                    id="nombre_obra"
                                    name="nombre_obra"
                                    type="text"
                                    placeholder="Nombre del Proyecto / Alias"
                                    //value={localData.nombre_obra || ''}
                                    value={datosGenerales.nombre_obra || ''}
                                    onChange={handleInputChange}
                                    //onChange={e => handleInputChange(e)}
                                    //onChange={e => handleInputChangeNombreObra(e)}
                                />
                                {datosGenerales.nombre_obra.trim() === '' && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Campo obligatorio
                                    </p>
                                )}
                            </div>

                            <div className="grid grid-cols-2 gap-4 px-2">{/*un div para las dos fechas */}
                                <div className="w-full">
                                    <Label htmlFor="fecha carga">Fecha de carga</Label>
                                    <div className="mt-1">
                                    <DatePicker
                                        disabled
                                        required
                                        dateFormat="dd/MM/yyyy"
                                        selected={fechaCargaAjustada}//{datosGenerales.fecha_carga}
                                        className="w-full border border-gray-300 rounded-md bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 px-3 h-10"
                                        wrapperClassName="w-full"
                                    /> {/* onChange={(date) => setStartDate(date)} */}
                                    </div>
                                </div>

                                <div className="w-full">
                                    <Label htmlFor="fecha actualizacion">Última actualización</Label>
                                    <div className="mt-1">
                                    <DatePicker
                                        disabled
                                        required
                                        dateFormat="dd/MM/yyyy"
                                        selected={fechaActualizacionAjustada || ""}//{datosGenerales.fecha_actualizacion || ""}
                                        //selected={fechaActualizacion}//usar el useMemo
                                        className="w-full border border-gray-300 rounded-md bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 px-3 h-10"
                                        wrapperClassName="w-full"
                                        //onChange={(date) => setStartDate(date)}
                                        onChange={(date) => updateField('formA', 'datosGenerales', 'fecha_actualizacion', date)}
                                    />
                                    </div>
                                </div>
                            </div>

                            <div className="px-2">
                                <Label htmlFor="encargado_proyecto">Encargado de Proyecto</Label>
                                <Select_simple
                                    options={optionsEncargadoProyecto}
                                    id="encargado_proyecto"
                                    name="encargado_proyecto"
                                    placeholder="Seleccionar..."
                                    value={datosGenerales.encargado_proyecto}
                                    onChange={e => handleInputChange(e)}
                                />
                                {datosGenerales.encargado_proyecto === "" && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Campo obligatorio
                                    </p>
                                )}
                            </div>

                            <div className="px-2">
                                {nuevaONG && (
                                    <p>Se ha creado una nueva ONG: {nuevaONG.ong}</p>
                                )}
                                <SubsidioForm />

                            </div>

                            {/* POR AHORA SE VA
                            <div className="px-2">
                                <Label htmlFor="presidente_ong">Presidente ONG / Intendente</Label>
                                <Input
                                    id="presidente_ong"
                                    name="presidente_ong"
                                    type="text"
                                    placeholder="Presidente ONG / Intendente"
                                    value={presidente_ong || ''}
                                    onChange={e => onChange(e)}
                                />
                            </div>*/}

                            {/*vuelve 7nov 2025 REFERENTES por ahora se va 14-JUN-2025*/}
                            <div className="px-2">
                                {/*{nuevoReferente && (
                                    <p>Se ha creado un nuevo referente: {nuevoReferente.nombre}</p>
                                )}}*/}
                                <Label htmlFor="referente_politico_nombre">Referente</Label>
                                <Input
                                    id="referente_politico_nombre"
                                    name="referente_politico_nombre"
                                    type="text"
                                    placeholder="Referente"
                                    value={datosGenerales.referente_politico_nombre || ''}
                                    onChange={e => handleInputChange(e)}
                                />
                            </div>

                            <div className="px-2">
                                <Label htmlFor="area_responsable">Área responsable</Label>
                                <Select_simple
                                    id="area_responsable"
                                    options={optionsAreaResponsable}
                                    name="area_responsable"
                                    placeholder="Seleccionar..."
                                    value={datosGenerales.area_responsable}
                                    onChange={e => handleInputChange(e)}
                                />
                                {datosGenerales.area_responsable === "" && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Campo obligatorio
                                    </p>
                                )}
                            </div>

                            <div className="px-2">
                                <Label htmlFor="programa_lineamiento">Programa</Label>
                                <Select_simple
                                    id="programa_lineamiento"
                                    options={optionsPrograma}
                                    name="programa_lineamiento"
                                    //placeholder="Programa"
                                    value={datosGenerales.programa_lineamiento}
                                    onChange={e => handleInputChange(e)}
                                    placeholder="Seleccionar..."
                                />
                            </div>

                            {/* renderizado para programa opcion 1*/}

                            {datosGenerales.programa_lineamiento === 'Mejora del Hábitat' && (
                                <div className="px-2">
                                    <Label htmlFor="modalidad">Modalidad</Label>
                                    <Select_simple
                                        id="modalidad"
                                        name="modalidad"
                                        options={optionsModalidadUNO}
                                        //placeholder="Modalidad"
                                        value={datosGenerales.modalidad}
                                        onChange={e => handleInputChange(e)}
                                    />
                                </div>
                            )
                            }

                            {datosGenerales.programa_lineamiento === 'Fortalecimiento de Organizaciones de la Comunidad y Municipios para la producción del Hábitat' && (
                                <div className="px-2">
                                    <Label htmlFor="modalidad">Modalidad</Label>
                                    <Select_simple
                                        id="modalidad"
                                        name="modalidad"
                                        options={optionsModalidadDOS}
                                        //placeholder="Modalidad"
                                        value={datosGenerales.modalidad}
                                        onChange={e => handleInputChange(e)}
                                    />
                                </div>
                            )
                            }

                            {!['Fortalecimiento de Organizaciones de la Comunidad y Municipios para la producción del Hábitat', 'Mejora del Hábitat'].includes(datosGenerales.programa_lineamiento) && (
                                <div className="px-2">
                                    <Label htmlFor="modalidad">Modalidad</Label>
                                    <select
                                        disabled
                                        className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700"
                                        id="modalidad"
                                        name="modalidad"
                                        options=""
                                        //placeholder="Modalidad"
                                        value={datosGenerales.modalidad}
                                        onChange={e => handleInputChange(e)}
                                    />
                                </div>
                            )
                            }

                            <div className="px-2">
                                <Label htmlFor="beneficiarios">Beneficiarios</Label>
                                <Input
                                    id="beneficiarios"
                                    name="beneficiarios"
                                    type="text"
                                    placeholder="Beneficiarios"
                                    value={datosGenerales.beneficiarios || ''}
                                    onChange={e => handleInputChange(e)}
                                />
                            </div>

                            <div className="flex flex-row">{/*un div para las dos fechas */}

                                <div className="w-1/2 px-2">
                                    <InputMontoObra
                                        //formattedValue={formattedValue}
                                        //numericValue={numericValue}
                                        //setFormattedValue={handleChangeFormattedValue}
                                        //setNumericValue={handleChangeNumericValue}
                                    />                                    
                                </div>

                                <div className="w-1/2 px-2">
                                    <Label htmlFor="fecha_imputacion">Fecha de imputacion</Label>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={fechaImputacionAjustada || ""}//{_fecha_imputacion || ""}
                                        className="mt-1 block w-full border border-gray-300 rounded-md bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 px-3 h-10"
                                        wrapperClassName="w-full"
                                        onChange={(date) => handleChangeDate({ name: "fecha_imputacion", value: date })}
                                    />
                                </div>
                            </div>

                            <div className="px-2">
                                <Label htmlFor="tipo_contratacion">Tipo contratación</Label> {/*15 */}
                                <Select_simple
                                    id="tipo_contratacion"
                                    options={optionsTipoContratacion}
                                    name="tipo_contratacion"
                                    //placeholder="Tipo contratación"
                                    value={datosGenerales.tipo_contratacion}
                                    onChange={e => handleInputChange(e)}
                                />
                            </div>

                            <div className="px-2">
                                <Label htmlFor="plazo_obra">Plazo de obra (días)</Label> {/*20*/}
                                <Input
                                    id="plazo_obra"
                                    name="plazo_obra"
                                    type="text"
                                    placeholder="Plazo de obra"
                                    value={datosGenerales.plazo_obra || ''}
                                    onChange={e => handleInputChange(e)}
                                />
                            </div>

                            <div className="px-2">
                                <Label htmlFor="estado">Estado</Label> {/*16 */}
                                <Select_simple
                                    id="estado"
                                    options={optionsEstado}
                                    name="estado"
                                    //placeholder="Estado"
                                    value={datosGenerales.estado}
                                    onChange={e => handleInputChange(e)}
                                    placeholder="Seleccionar..."
                                />
                            </div>

                        </div>{/* cierra COLUMN UNO */}

                        <div className="space-y-4"> {/* COLUMNA DOS - para la otra mitad de DAtos generales*/}

                            <h2 className="text-xl font-bold mb-2">LOCALIZACION</h2>

                            <div className="px-2">
                                <Label htmlFor="lc_21_localidad">
                                    Localidad
                                </Label>
                                <Input
                                    type="text"
                                    name="lc_21_localidad"
                                    value={datosGenerales.lc_21_localidad || ""}
                                    onChange={e => handleInputChange(e)}
                                    required
                                />
                            </div>                            

                            <div className="px-2">
                                {/*onChangeLocalizacion*/}
                                <Label htmlFor="lc_22_identificacion_catastral">
                                    Identificación catastral
                                </Label>
                                <Select_simple
                                    name="lc_22_identificacion_catastral"
                                    value={datosGenerales.lc_22_identificacion_catastral}
                                    options={optionsIdentificacionCatastral}
                                    onChange={e => handleInputChange(e)}
                                    //className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700"
                                />
                            </div>

                            {/*lc_22_identificacion_catastral === "" && (
                                <div className="px-2">
                                    <Label htmlFor="lc_22_1_datos_catastrales" className="text-white dark:text-gray-900">.</Label>
                                    <Input
                                        disabled
                                        name="lc_22_1_datos_catastrales"
                                        type="text"
                                        placeholder=""
                                        value={""}
                                    />
                                </div>
                            )*/}

                            {datosGenerales.lc_22_identificacion_catastral === "SI" && (
                                <>
                                    <div className="px-2">
                                        <Label htmlFor="lc_22_1_datos_catastrales">
                                            Datos catastrales
                                        </Label>
                                        <Input
                                            type="text"
                                            name="lc_22_1_datos_catastrales"
                                            value={datosGenerales.lc_22_1_datos_catastrales}
                                            onChange={e => handleInputChange(e)}
                                        />
                                    </div>
                                    <div className="px-2">
                                    <Label htmlFor="lc_22_2_cuadro_calles" >
                                        Cuadro de Calles
                                    </Label>
                                    <Input
                                        type="text"
                                        name="lc_22_2_cuadro_calles"
                                        value={datosGenerales.lc_22_2_cuadro_calles}
                                        onChange={e => handleInputChange(e)}
                                    />
                                    </div>
                                </>
                            )}

                            {datosGenerales.lc_22_identificacion_catastral === "NO" && (
                                <div className="px-2">
                                    <Label htmlFor="lc_22_2_cuadro_calles" >
                                        Cuadro de Calles
                                    </Label>
                                    <Input
                                        type="text"
                                        name="lc_22_2_cuadro_calles"
                                        value={datosGenerales.lc_22_2_cuadro_calles}
                                        onChange={e => handleInputChange(e)}
                                    />
                                </div>
                            )}

                            <div className="px-2">
                                <Label htmlFor="lc_24_titular_dominio">
                                    Titular de dominio
                                </Label>
                                <Input
                                    type="text"
                                    name="lc_24_titular_dominio"
                                    value={datosGenerales.lc_24_titular_dominio || ""}
                                    onChange={e => handleInputChange(e)}
                                />
                            </div>

                            <div className="mb-6">
                                <Label htmlFor="lc_23_observaciones_localizacion">
                                    Observaciones de Localización
                                </Label>
                                <p className="text-sm text-gray-500">
                                    **Consignar los folios de los barrios donde se interviene y cantidad de mejoras por barrio**
                                </p>
                                <textarea
                                    value={datosGenerales.lc_23_observaciones_localizacion || ''}
                                    maxLength="2000"
                                    name="lc_23_observaciones_localizacion"
                                    onChange={e => handleInputChange(e)}
                                    className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md resize-none focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 resize-y"
                                    rows="4"
                                    placeholder="Observaciones de localización"
                                />                               
                                <div>
                                    {/*<p align="right" style={{height: "5px", fontSize: "0.9em"}}>Caracteres restantes: {contadorCaracteresRestantes(2000, textInput2.length)}</p><br/>*/}
                                    <p align="right" className="text-sm text-gray-500" style={{height: "5px", fontSize: "0.9em"}}>
                                        Caracteres restantes: {contadorCaracteresRestantes(2000, datosGenerales.lc_23_observaciones_localizacion)}
                                    </p>
                                </div>
                            </div>

                            <div className="mb-6 dark">
                                { datosGenerales.area_responsable === 'ÁREA DE PROYECTOS' && <Modal2 
                                    partido={datosGenerales?.partido}
                                />}
                                {role === 'admin' && drawnFeatures.length > 0 && (
                                    <div className={`mb-6 p-4 border rounded ${isDarkMode ? 'border-gray-600 bg-gray-800' : 'border-gray-300 bg-white'}`}>
                                        <div className="flex justify-between items-center mb-2">
                                            <h3 className="font-bold text-lg">Datos del Mapa (Solo Admin)</h3>
                                            <button                                                
                                                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                                                title="Cerrar"
                                            >
                                                ×
                                            </button>
                                        </div>
                                        <div className="space-y-2">
                                            <div className="space-y-2">
                                                {drawnFeatures.map((feature, index) => (
                                                    <div key={index} className="text-sm text-gray-600 dark:text-gray-300">
                                                        <span className="font-medium">Feature {index + 1}:</span>
                                                        <div className="ml-4">
                                                            <div>
                                                                <span className="font-medium">ID:</span> {feature.id}
                                                            </div>
                                                            <div>
                                                                <span className="font-medium">WKT:</span> {feature.wkt?.substring(0, 50)}...
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="mt-2">
                                                <details className="text-sm">
                                                    <summary className="cursor-pointer text-blue-500 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300">
                                                        Ver datos completos
                                                    </summary>
                                                    <pre className="mt-2 p-2 bg-gray-100 dark:bg-gray-700 rounded overflow-auto max-h-48 text-xs">
                                                        {JSON.stringify(drawnFeatures, null, 2)}
                                                    </pre>
                                                </details>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="px-2">
                                <Label htmlFor="barrio_tipo">Barrio</Label>
                                <Select_simple
                                    id="barrio_tipo"
                                    name="barrio_tipo"
                                    options={optionsBarrioTipo}
                                    value={datosGenerales.barrio_tipo || ''}
                                    onChange={e => handleInputChange(e)}
                                    disabled={!datosGenerales.partido}
                                />
                            </div>
                            
                            {datosGenerales.barrio_tipo === 'RPPVAP' && (
                                <div className="px-2">
                                    <Label htmlFor="barrio_rppvap_nombre">Seleccionar Barrio RPPVAP</Label>
                                    <Select_simple
                                        name="barrio_rppvap_nombre"
                                        options={[
                                            { value: '', label: 'Seleccionar...' },
                                            ...barriosRPPVAP.map(b => ({value: b.nombre_del_barrio, label: `${b.codigo_folio} - ${b.nombre_del_barrio}`}))
                                        ]}
                                        value={datosGenerales.barrio_rppvap_nombre}
                                        onChange={(e) => { handleInputChange(e) }}
                                    />
                                </div>
                            )
                            }

                            {datosGenerales.barrio_tipo === 'OTRO' && (
                                <div className="px-2">
                                    <Label htmlFor="barrio_otro_nombre">Nombre del Barrio</Label>
                                    <Input
                                        type="text"
                                        name="barrio_otro_nombre"
                                        value={datosGenerales.barrio_otro_nombre}
                                        //onChange={(e) => setBarrioOtro(e.target.value)}
                                        onChange={(e) => { handleInputChange(e) }}
                                        maxLength={100}
                                    />
                                    <p className="text-sm text-gray-500 mt-1">
                                        Indicar nombre, y fuente (si es Re.Na.Bap, Lotes con Servicios, Familia Propietaria u otro de corresponder)
                                    </p>
                                </div>
                            )
                            }
                        </div> {/* cierra COLUMN DOS */}

                    </div>
                </form>
            </div>

            <div className="p-4 bg-white dark:bg-gray-900 h-auto">
                <div className="space-y-2" >{/* aca no hace falta que se a form*/}
                    {/*<div className="bg-blue-300 dark:bg-gray-700 h-8 py-2">Prueba Tipo y subtipo</div>*/}


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        {/* COLUMNA UNO*/}
                        <div className="space-y-4 h-auto">
                            <h2 className="text-xl font-bold mb-2">TIPO Y SUBTIPO DE PROYECTO</h2>
                            <TipoProyectoSubform />
                            {/*<TipoProyectoSubform
                                
                                //onDataFromNieto={onDataFromNieto} //25JUL2025: NO usar - se quitó

                                onDataChangeSub={onDataChangeSub} //25JUL2025: pasar rows desde TipoProyectoSubform
                                arrayTipoSubtipoProyecto={datosGenerales.array_tipo_subtipo_proyecto} //NOTA 26JUL2025: pasamo al Sumformulario el array de Tipo y Subtipo Proyecto
                            />*/}

                            <div className="px-2">
                                <Label htmlFor="descripcion_proyecto">Descripcion del proyecto</Label>
                                <textarea
                                    value={datosGenerales.descripcion_proyecto || ''}
                                    maxLength="2000"
                                    name="descripcion_proyecto"
                                    onChange={e => handleInputChange(e)}
                                    className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md resize-none focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 resize-y"
                                    rows="4"
                                    placeholder="Descripcion del proyecto"
                                />                                
                                <div>
                                    {/*<p align="right" className="text-sm text-gray-500" style={{height: "5px", fontSize: "0.9em"}}>Caracteres restantes: {contadorCaracteresRestantes(2000, textInput1.length)}</p>*/}
                                    <p align="right" className="text-sm text-gray-500" style={{height: "5px", fontSize: "0.9em"}}>
                                        Caracteres restantes: {contadorCaracteresRestantes(2000, datosGenerales.descripcion_proyecto)}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* COLUMNA DOS*/}
                        <div className="space-y-4">
                            <h2 className="text-xl font-bold mb-2">EXPEDIENTES</h2>
                            <ExpedienteSubform />
                            {/*<ExpedienteSubform
                                arrayObrasExpediente={array_obras_expediente}
                                onRegistroChange={onRegistroChange}
                                registro={registro} //Pasamos el registro completo para poder actualizarlo desde el nieto
                            />*/}
                        </div>
                    </div>
                </div>
            </div>   

        </>
    )
}

export default memo(FormA);
